import { useState } from "react";
import { Alert } from "@interstate/components/Alert";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { StyledContainerAlert } from "./styled";

export interface EmojiPickerErrorAlertProps {
  emojiPickerError: boolean;
}

export function EmojiPickerErrorAlert({
  emojiPickerError
}: EmojiPickerErrorAlertProps) {
  const [dismissed, setDismissed] = useState(false);

  if (!emojiPickerError || dismissed) {
    return null;
  }

  return (
    <StyledContainerAlert>
      <Alert
        data-testid="emoji-picker-error-message-reply-app"
        displayCloseButton={true}
        role="info"
        type="info"
        onCloseClick={() => setDismissed(true)}
      >
        <span>{ErrorMessages.EMOJI_PICKER_LOAD_ERROR}</span>
      </Alert>
    </StyledContainerAlert>
  );
}
